module.exports = __webpack_public_path__ + "img/转账汇款.f455d76d.png";